import { render, staticRenderFns } from "./SizeRecommendationSizeFeedbackCard.vue?vue&type=template&id=edd247fe&scoped=true"
import script from "./SizeRecommendationSizeFeedbackCard.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationSizeFeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationSizeFeedbackCard.vue?vue&type=style&index=0&id=edd247fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd247fe",
  null
  
)

/* custom blocks */
import block0 from "./SizeRecommendationSizeFeedbackCard.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports